export const normalized = (v: string) => v.toLowerCase().trim()

export const matches = (value: string, query: string) =>
  normalized(value).includes(normalized(query))
